import React from 'react';

import useArgsAddedQuery from '@job-facets/redux/reusableComponents';
import FacetsModule from '@job-facets/components/facets/Module';
import PaginationSection from '@job-facets/components/pagination/View';
import JobCards from '@job-facets/components/job-cards/View';
import HeaderHeroLayout from '@job-facets/components/header-hero/View';
import EasyApply from './easy_apply/View';
import skeletonJobs from '@job-facets/utility/preloadData';

import { __ } from '@wordpress/i18n';

function RootAppLayout() {
	const { data, isFetching, isLoading } = useArgsAddedQuery();
	const jobListings = data?.jobs;

	let isLoaderActive = false;
	if (isFetching || isLoading) {
		isLoaderActive = true;
	}

	return (
		<>
			<HeaderHeroLayout />

			<div className='container'>
				<h3 className='h3 mb-15'>{__('Latest jobs', 'job')}</h3>
				<div className='ss-section results'>
					<div className='results__facets'>
						<FacetsModule />
					</div>
					<div className='results__jobs' data-js-used-for-pagination-scrolling>
						<EasyApply />

						{jobListings &&
							Array.isArray(jobListings) &&
							jobListings.length === 0 && (
								<p className='text-center'>{__('No jobs found.', 'job')}</p>
							)}

						{!Array.isArray(jobListings) && (
							<JobCards jobsLists={skeletonJobs} loader={true} />
						)}

						{jobListings &&
							Array.isArray(jobListings) &&
							jobListings.length > 0 && (
								<JobCards jobsLists={jobListings} loader={isLoaderActive} />
							)}

						{/* <JobCards jobsLists={skeletonJobs} loader={true} /> */}

						<PaginationSection />
					</div>
				</div>
			</div>
		</>
	);
}

export default RootAppLayout;
